import { render, staticRenderFns } from "./ElTypography.vue?vue&type=template&id=a2cd597a"
import script from "./ElTypography.vue?vue&type=script&lang=js"
export * from "./ElTypography.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports